import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    // Root-relative URL: `./assets/...` breaks under locale-prefixed routes (e.g. `/fr/auth/login`
    // resolves to `/fr/assets/...` and 404s).
    return this.http.get(`/assets/i18n/${lang}.json`);
  }

}
